module.exports = __webpack_public_path__ + "img/PDF.81c7aec3.png";